import React, { useContext, useEffect, useState } from "react";
import { RootContext } from "../../RootContextProvider";

import { Input, Button, Checkbox, message, Radio } from "antd";
import {
  SiTiktok,
  SiFacebook,
  SiInstagram,
  SiSnapchat,
  SiLinkedin,
  SiTwitter,
  SiTwitch,
  SiYoutube,
} from "react-icons/si";
import { updateSocialIcons } from "../../utils/pages";
import { validateSocialLinks } from "../../utils/utils";

const PageSettingsSocial = ({
  refreshContextProvider,
  loading,
  setLoading,
}) => {
  const { pages } = useContext(RootContext);
  const [socialsBottom, setSocialBottom] = useState();
  const [facebook, setFacebook] = useState({
    type: "facebook",
    display: false,
    url: "",
  });
  const [instagram, setInstagram] = useState({
    type: "instagram",
    display: false,
    url: "",
  });
  const [linkedin, setLinkedin] = useState({
    type: "linkedin",
    display: false,
    url: "",
  });
  const [twitter, setTwitter] = useState({
    type: "twitter",
    display: false,
    url: "",
  });
  const [youtube, setYoutube] = useState({
    type: "youtube",
    display: false,
    url: "",
  });
  const [twitch, setTwitch] = useState({
    type: "twitch",
    display: false,
    url: "",
  });
  const [snapchat, setSnapchat] = useState({
    type: "snapchat",
    display: false,
    url: "",
  });
  const [tiktok, setTiktok] = useState({
    type: "tiktok",
    display: false,
    url: "",
  });

  useEffect(() => {
    const setSocialStates = () => {
      setLoading(true);
      let socials;
      if (pages.SocialLinks) {
        socials = JSON.parse(pages.SocialLinks);
      } else {
        socials = [];
      }
      for (const social of socials) {
        if (social.type === "facebook") {
          setFacebook(social);
        } else if (social.type === "instagram") {
          setInstagram(social);
        } else if (social.type === "tiktok") {
          setTiktok(social);
        } else if (social.type === "twitter") {
          setTwitter(social);
        } else if (social.type === "youtube") {
          setYoutube(social);
        } else if (social.type === "linkedin") {
          setLinkedin(social);
        } else if (social.type === "snapchat") {
          setSnapchat(social);
        } else if (social.type === "twitch") {
          setTwitch(social);
        }
      }
      if (pages.SocialLinksBottom) {
        setSocialBottom(true);
      } else {
        setSocialBottom(false);
      }
    };
    try {
      setSocialStates();
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, []);

  const updateSocials = async () => {
    try {
      console.log("updating socials");
      setLoading(true);
      let socials = [
        facebook,
        instagram,
        linkedin,
        twitter,
        youtube,
        twitch,
        snapchat,
        tiktok,
      ];
      let socialsToSave = [];

      for (const social of socials) {
        if (social.display) {
          let isValid = await validateSocialLinks(social);
          if (!isValid.valid) {
            setLoading(false);
            message.error(isValid.error);
            return;
          } else {
            socialsToSave.push(social);
          }
        }
      }
      let data = {
        socialsToSave,
        socialsBottom,
      };
      await updateSocialIcons(pages.PageID, data);
      refreshContextProvider();
      message.success("Réseaux sociaux mis à jour");
      setLoading(false);
    } catch (e) {
      console.log(e);
      message.error("Erreur lors de la sauvegarde");
    }
  };

  return (
    <div className="block-container">
      {" "}
      <div className="secondary-title">Réseaux sociaux</div>
      <div className="block-section">
        <div className="script-type">
          <div className="third-title social radio">
            <div>Placement des réseaux sociaux</div>
            <Radio.Group
              onChange={(e) => {
                setSocialBottom(e.target.value);
              }}
              value={socialsBottom}
            >
              <Radio value={true}>Bas de page</Radio>
              <Radio value={false}>Haut de page</Radio>
            </Radio.Group>
          </div>
        </div>
        <div className="script-type">
          <div className="third-title social">
            <Checkbox
              onChange={() => {
                setFacebook({ ...facebook, display: !facebook.display });
              }}
              checked={facebook.display}
            />
            <div className="name">
              <SiFacebook style={{ marginRight: "10px" }} />
              Facebook
            </div>
          </div>
          {facebook.display ? (
            <div className="script-input">
              <Input
                defaultValue={facebook.url}
                onChange={(e) => {
                  setFacebook({ ...facebook, url: e.target.value.trim() });
                }}
                placeholder="URL de votre page Facebook, ex : https://www.facebook.com/ma-page-facebook"
                maxLength={250}
              />
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="script-type">
          <div className="third-title social">
            {" "}
            <Checkbox
              onChange={() => {
                setInstagram({ ...instagram, display: !instagram.display });
              }}
              checked={instagram.display}
            />
            <div className="name">
              <SiInstagram style={{ marginRight: "10px" }} />
              Instagram
            </div>
          </div>
          {instagram.display ? (
            <div className="script-input">
              <Input
                defaultValue={instagram.url}
                onChange={(e) => {
                  setInstagram({ ...instagram, url: e.target.value.trim() });
                }}
                placeholder="Nom d'utilisateur Instagram"
                maxLength={200}
              />
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="script-type">
          <div className="third-title social">
            {" "}
            <Checkbox
              onChange={() => {
                setTiktok({ ...tiktok, display: !tiktok.display });
              }}
              checked={tiktok.display}
            />
            <div className="name">
              <SiTiktok style={{ marginRight: "10px" }} />
              Tiktok
            </div>
          </div>
          {tiktok.display ? (
            <div className="script-input">
              <Input
                defaultValue={tiktok.url}
                onChange={(e) => {
                  setTiktok({ ...tiktok, url: e.target.value.trim() });
                }}
                placeholder="Nom d'utilisateur Tiktok sans @"
                maxLength={200}
              />
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="script-type">
          <div className="third-title social">
            {" "}
            <Checkbox
              onChange={() => {
                setTwitter({ ...twitter, display: !twitter.display });
              }}
              checked={twitter.display}
            />
            <div className="name">
              <SiTwitter style={{ marginRight: "10px" }} />
              Twitter
            </div>
          </div>
          {twitter.display ? (
            <div className="script-input">
              <Input
                defaultValue={twitter.url}
                onChange={(e) => {
                  setTwitter({ ...twitter, url: e.target.value.trim() });
                }}
                placeholder="Nom d'utilisateur Twitter sans @"
                maxLength={80}
              />
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="script-type">
          <div className="third-title social">
            {" "}
            <Checkbox
              onChange={() => {
                setYoutube({ ...youtube, display: !youtube.display });
              }}
              checked={youtube.display}
            />
            <div className="name">
              <SiYoutube style={{ marginRight: "10px" }} />
              Youtube
            </div>
          </div>
          {youtube.display ? (
            <div className="script-input">
              <Input
                defaultValue={youtube.url}
                onChange={(e) => {
                  setYoutube({ ...youtube, url: e.target.value.trim() });
                }}
                placeholder="URL de votre chaîne Youtube, ex : https://www.youtube.com/c/aMOODIEsqueezie/"
                maxLength={200}
              />
            </div>
          ) : (
            ""
          )}{" "}
        </div>
        <div className="script-type">
          <div className="third-title social">
            {" "}
            <Checkbox
              onChange={() => {
                setLinkedin({ ...linkedin, display: !linkedin.display });
              }}
              checked={linkedin.display}
            />
            <div className="name">
              <SiLinkedin style={{ marginRight: "10px" }} />
              Linkedin
            </div>
          </div>
          {linkedin.display ? (
            <div className="script-input">
              <Input
                defaultValue={linkedin.url}
                onChange={(e) => {
                  setLinkedin({ ...linkedin, url: e.target.value.trim() });
                }}
                placeholder="URL de votre page Linkedin"
                maxLength={200}
              />
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="script-type">
          <div className="third-title social">
            {" "}
            <Checkbox
              onChange={() => {
                setSnapchat({ ...snapchat, display: !snapchat.display });
              }}
              checked={snapchat.display}
            />
            <div className="name">
              <SiSnapchat style={{ marginRight: "10px" }} />
              Snapchat
            </div>
          </div>
          {snapchat.display ? (
            <div className="script-input">
              <Input
                defaultValue={snapchat.url}
                onChange={(e) => {
                  setSnapchat({ ...snapchat, url: e.target.value.trim() });
                }}
                placeholder="Nom d'utilisateur Snapchat"
                maxLength={40}
              />
            </div>
          ) : (
            ""
          )}{" "}
        </div>
        <div className="script-type">
          <div className="third-title social">
            {" "}
            <Checkbox
              onChange={() => {
                setTwitch({ ...twitch, display: !twitch.display });
              }}
              checked={twitch.display}
            />
            <div className="name">
              <SiTwitch style={{ marginRight: "10px" }} />
              Twitch
            </div>
          </div>
          {twitch.display ? (
            <div className="script-input">
              <Input
                defaultValue={twitch.url}
                onChange={(e) => {
                  setTwitch({ ...twitch, url: e.target.value.trim() });
                }}
                placeholder="Nom de votre chaîne Twitch"
                maxLength={40}
              />
            </div>
          ) : (
            ""
          )}{" "}
        </div>
        <div className="button-spacing">
          <Button
            onClick={() => {
              updateSocials();
            }}
            loading={loading}
            type="secondary"
          >
            Sauvegarder
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PageSettingsSocial;
